export enum LookUpResult {
  Undefined = 0,
  Adulterated = 1,
  Completed = 2,
  Negative = 3,
  NegativeDilute = 4,
  Pending = 5,
  Positive = 6,
  PositiveDilute = 7,
  Cancel = 8,
  RejectedCancelNoTest = 9,
  InvalidResultLab = 10,
  PreliminaryNeg = 11,
  RefusalAdulterated = 12,
  RefusalOther = 13,
  RefusalSubstituted = 14,
  RefusalShyLungBladder = 15,
  RejectedLab = 16,
  SubstitutedLab = 17,
  PendingFurtherTesting = 19,
  Refusal = 20,
  Unable = 21,
  Detected = 22,
  InvalidResult = 23,
  NotDetected = 24,
  PositiveUnableToContactDonor = 25,
  Rejected = 26,
  Substituted = 27,
  Reconfirmed = 28,
  FailedToReconfirm = 29,
  UnableToComplete = 30,
}
